export interface ActivityFilter {
    paidByUserIds: number[]
    owesUserIds: number[]
    payUpUserIds: number[]
}

export const EMPTY_ACTIVITY_FILTER: ActivityFilter = {
    paidByUserIds: [],
    owesUserIds: [],
    payUpUserIds: [],
}

export const isFilterActive = (filter: ActivityFilter): boolean =>
    filter.paidByUserIds.length > 0 ||
    filter.owesUserIds.length > 0 ||
    filter.payUpUserIds.length > 0

export const countFilterCategories = (filter: ActivityFilter): number =>
    (filter.paidByUserIds.length > 0 ? 1 : 0) +
    (filter.owesUserIds.length > 0 ? 1 : 0) +
    (filter.payUpUserIds.length > 0 ? 1 : 0)
